// extracted by mini-css-extract-plugin
export default {"edit":"CategoryEdit-module__edit__mqMpf","form":"CategoryEdit-module__form__K1iF6","footer":"CategoryEdit-module__footer__Xfs8W","button":"CategoryEdit-module__button__zppJK"};